import { APP_TEXTS } from '../../../../../texts/texts';
import loadingParams from './loadingParams';

export const loadTypes = {
  STANDARD: 'standard',
  SEISMIC: 'seismic',
  FIRE: 'fire'
};

export class Combination {

  constructor(
    index = 1,
    name = null,
    Nz = 0,
    Vx = 0,
    Vy = 0,
    Mx = 0,
    My = 0,
    Mz = 0,
    loadType = loadTypes.STANDARD,
    isSelected = true,
    isRemoved = false,
    isActive = false,
    influence = null
  ) {
    this.Nz = Nz;
    this.Vx = Vx;
    this.Vy = Vy;
    this.Mx = Mx;
    this.My = My;
    this.Mz = Mz;
    this.loadType = loadType;
    this.isSelected = isSelected;
    this.isRemoved = isRemoved;
    this.isActive = isActive;
    this.influence = influence;
    this.name = name || `${APP_TEXTS.LOADS_COMBINATION_NAME.Content.replace("{0}", index + 1)}`;
  }

  /// switch the headers order
  /// Nz: 1, Vx: 2, Vy: 3 => Vy: 1, Vx: 2, Nz: 3
  switchHeadersOrder(newOrder) {
    let newComb = new Combination(this.index, this.name, 0, 0, 0, 0, 0, 0, 
      this.loadType, this.isSelected, this.isRemoved, this.isActive, this.influence);
    newOrder.forEach((item, index) => {
      newComb[item.replace('-', '')] = this[loadingParams[index].key] * (item.includes('-') ? -1 : 1);
    });

    return newComb;
  }
  
  /// switch the values to match the new headers order
  /// Nz: 1, Vx: 2, Vy: 3 => Nz: 3, Vx: 2, Vy: 1
  switchValuesOrder(newOrder) {
    let newComb = new Combination(this.index, this.name, 0, 0, 0, 0, 0, 0, 
      this.loadType, this.isSelected, this.isRemoved, this.isActive, this.influence);
    loadingParams.forEach((item, index) => {
      newComb[item.key] = this[newOrder[index].replace('-', '')] * (newOrder[index].includes('-') ? -1 : 1);
    });

    return newComb;
  }

  getImportLoadName(loadName, headers) {
    let index = headers.findIndex(header => header.includes(loadName));
    if (index !== -1) {
      return loadingParams[index].key;
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/misc/combination.class.js